import SpotCheckList from './SpotCheckList';
export default SpotCheckList;